import type { ComponentType } from 'react';

export type CtxItem = {
  key: string;
  label: string;
  icon: ComponentType<{ className?: string }>;
  onClick: () => void;
  danger?: boolean;
  disabled?: boolean;
  hint?: string;
  /** Draw a thin divider above this item. */
  sep?: boolean;
};

interface FlowContextMenuProps {
  x: number;
  y: number;
  items: CtxItem[];
  onClose: () => void;
}

const MENU_WIDTH = 200;

export function FlowContextMenu({ x, y, items, onClose }: FlowContextMenuProps) {
  const left = Math.max(8, Math.min(x, window.innerWidth - MENU_WIDTH - 8));
  const top = Math.max(8, Math.min(y, window.innerHeight - (items.length * 34 + 20)));

  return (
    <div
      className="fixed inset-0 z-[70]"
      onPointerDown={onClose}
      onContextMenu={(event) => {
        event.preventDefault();
        onClose();
      }}
    >
      <div
        onPointerDown={(event) => event.stopPropagation()}
        onContextMenu={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
        style={{ left, top, width: MENU_WIDTH }}
        className="absolute flex flex-col gap-px rounded-[10px] border border-slate-700/70 bg-slate-900 p-1.5 shadow-[0_18px_50px_rgba(0,0,0,0.6)]"
      >
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.key}
              type="button"
              disabled={item.disabled}
              onClick={() => {
                if (item.disabled) return;
                item.onClick();
                onClose();
              }}
              className={`flex w-full items-center gap-2.5 rounded-md px-2.5 py-[7px] text-left text-[13px] transition-colors ${
                item.sep ? 'mt-1.5 shadow-[0_-3px_0_-2px_var(--color-slate-700)]' : ''
              } ${
                item.disabled
                  ? 'cursor-default text-slate-600'
                  : item.danger
                  ? 'text-red-300 hover:bg-red-500/10'
                  : 'text-slate-100 hover:bg-slate-800'
              }`}
            >
              <Icon
                className={`h-[15px] w-[15px] shrink-0 ${
                  item.disabled ? 'text-slate-600' : item.danger ? 'text-red-300' : 'text-violet-300'
                }`}
              />
              <span className="flex-1">{item.label}</span>
              {item.hint && <span className="text-[10.5px] text-slate-500">{item.hint}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
